import { FaRegHeart, FaRegStar } from "react-icons/fa";
import { GiCat } from "react-icons/gi";

const shapes = [
  { Icon: FaRegStar, className: "shape s1" },
  { Icon: FaRegHeart, className: "shape h1" },
  { Icon: GiCat, className: "shape c1" },

  { Icon: FaRegStar, className: "shape s2" },
  { Icon: FaRegHeart, className: "shape h2" },
  { Icon: GiCat, className: "shape c2" },

  { Icon: FaRegStar, className: "shape s3" },
  { Icon: FaRegHeart, className: "shape h3" },
  { Icon: GiCat, className: "shape c3" },

  { Icon: FaRegStar, className: "shape s4" },
  { Icon: FaRegHeart, className: "shape h4" },
  { Icon: GiCat, className: "shape c4" },

  { Icon: FaRegStar, className: "shape s5" },
  { Icon: FaRegHeart, className: "shape h5" },
];

function BackgroundDecor() {
  return (
    <div className="cute-bg" aria-hidden="true">
      {shapes.map(({ Icon, className }, index) => (
        <span key={index} className={className}>
          <Icon />
        </span>
      ))}
    </div>
  );
}

export default BackgroundDecor;